import { com } from '@eidu/web'
import entityApiUrl from '../entity/baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import SemanticLinksResponse = com.eidu.sharedlib.entity.analytics.SemanticLinksResponse

const getSemanticLinks = async (): Promise<readonly SemanticLink[]> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links`
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return SemanticLinksResponse.fromJsonString(await response.text()).semanticLinks.asJsReadonlyArrayView()
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityTypes endpoint`)
    }
  })
}

export default getSemanticLinks
